import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { AllServicesResponse } from './all-services.model';

export class allServicesEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  http = inject(HttpClient);

  get() {
    return this.http.get<AllServicesResponse>(`${this.env.constants.API_URL}/states/UK`);
  }
}
